
import * as React from 'react';
import { areShallowDifferent } from '@ms/utilities-objects/lib/areShallowEqual';

/**
 * Hook which evaluates the given expression only if the given deps object is shallow-different than
 * for the previous invocation of the hook.
 * This is essentially `React.useMemo`, except it shallow-compares a single deps object
 * rather than an array of deps values.
 */
export function useShallowMemo<TValue>(getValue: () => TValue, deps: object): TValue {
  const ref = React.useRef<object>();

  if (areShallowDifferent(ref.current, deps, { debug: true })) {
    ref.current = deps;
  }

  return React.useMemo(getValue, [ref.current]);
}
